import React from 'react'
import ServicesHero from './ServicesHero'
import SevicesSection1 from './SevicesSection1'

const Services = () => {
  return (
    <>
        <ServicesHero/>
   <SevicesSection1/>
    </>
  )
}

export default Services